/* eslint-disable max-len */
import { ERRORS } from '../constants';

export default {
  ERRORS: {
    [ERRORS.INVALID_PROZIS_POINTS]:
      'Oops, the ProzisPoints you wanted to share with the courier are no longer available. Please try again.'
  },
  MESSAGES: {
    ANSWERED_SURVEY:
      'We already have your feedback on the delivery of {code} order. \n\rLooking forward to hearing about your future experiences, though. 👍',
    AVAILABLE_POINTS: 'ProzisPoints available:',
    DO_NOT_SHARE_YOUR_POINTS: 'Don\'t tip',
    EXPERIENCE_EVALUATION: 'RATE YOUR DELIVERY EXPERIENCE',
    FEEDBACK_HERE: 'Leave your feedback here',
    FEEDBACK_THANKS:
      'Thanks for your feedback about the PROZIS NOW delivery service. \n\rWe will work on it! 💪',
    HOW_BE_BETTER: 'Tell us what we are doing right and what we should improve',
    MORE_TO_SAY: 'IMPROVE OURSELVES',
    SAY_HELP_TO_COURIER: 'Would you like to thank the courier?',
    SAY_HELP_TO_USER:
      'Would you like to thank the person who delivered your order?',
    SHARE_YOUR_POINTS:
      'Share your ProzisPoints with {name}. Your tip will be appreciated. 😉',
    TIP_COURIER: 'Tip {name}',
    TIP_USER: 'Tip {name}'
  }
};
